const api = {}
const requireContent = require.context('.', true, /\.js$/)
requireContent.keys().forEach((key) => {
  const content = requireContent(key)
  const contentName = key.replace(/^\.\//, '').replace(/\.\w+$/, '')
  // console.log({ content, contentName, __esModule: content.__esModule })
  api[contentName] = content.__esModule && content.default ? content.default : content
})
export default api



// WEBPACK FOOTER //
// ./src/api/index.js